import { render, staticRenderFns } from "./shopService.vue?vue&type=template&id=66c4e112&scoped=true"
import script from "./shopService.vue?vue&type=script&lang=js"
export * from "./shopService.vue?vue&type=script&lang=js"
import style0 from "./shopService.vue?vue&type=style&index=0&id=66c4e112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4e112",
  null
  
)

export default component.exports